import { BaseElement } from './base-element';
import { ElementType } from './element-type';

export class Footer extends BaseElement {
  constructor() {
    super();
    this.elementType = ElementType.footer;
  }
}
